import * as Constants from '../../constants';

// Anti-Austerity Protests
export const ANTI_AUSTERITY_PROTESTS_ID = 'anti-austerity-protests';
export const ANTI_AUSTERITY_PROTESTS_NAME = 'Anti-Austerity Protests';
export const INITIAL_ANTI_AUSTERITY_PROTESTS = {
    id: ANTI_AUSTERITY_PROTESTS_ID,
    name: ANTI_AUSTERITY_PROTESTS_NAME,
    cubes: [Constants.INCOME_CUBE, Constants.UNREST_CUBE]
};

// Back-to-Work Programme
export const BACK_TO_WORK_PROGRAMME_ID = 'back-to-work-programme';
export const BACK_TO_WORK_PROGRAMME_NAME = 'Back-to-Work Programme';
export const INITIAL_BACK_TO_WORK_PROGRAMME = {
    id: BACK_TO_WORK_PROGRAMME_ID,
    name: BACK_TO_WORK_PROGRAMME_NAME,
    cubes: [Constants.WELFARE_CUBE, Constants.WELFARE_CUBE]
};

// Budget Surplus
export const BUDGET_SURPLUS_ID = 'budget-surplus';
export const BUDGET_SURPLUS_NAME = 'Budget Surplus';
export const INITIAL_BUDGET_SURPLUS = {
    id: BUDGET_SURPLUS_ID,
    name: BUDGET_SURPLUS_NAME,
    cubes: [Constants.INCOME_CUBE, Constants.INCOME_CUBE]
};

// Early Repayments
export const EARLY_REPAYMENTS_ID = 'early-repayments';
export const EARLY_REPAYMENTS_NAME = 'Early Repayments';
export const INITIAL_EARLY_REPAYMENTS = {
    id: EARLY_REPAYMENTS_ID,
    name: EARLY_REPAYMENTS_NAME,
    cubes: [Constants.DEBT_CUBE, Constants.INCOME_CUBE]
};

// Economic Downturn
export const ECONOMIC_DOWNTURN_ID = 'economic-downtown';
export const ECONOMIC_DOWNTURN_NAME = 'Economic Downturn';
export const INITIAL_ECONOMIC_DOWNTURN = {
    id: ECONOMIC_DOWNTURN_ID,
    name: ECONOMIC_DOWNTURN_NAME,
    cubes: [Constants.DEBT_CUBE, Constants.DEBT_CUBE]
};

// Falling Crime Rates
export const FALLING_CRIME_RATES_ID = 'falling-crime-rates';
export const FALLING_CRIME_RATES_NAME = 'Falling Crime Rates';
export const INITIAL_FALLING_CRIME_RATES = {
    id: FALLING_CRIME_RATES_ID,
    name: FALLING_CRIME_RATES_NAME,
    cubes: [Constants.SECURITY_CUBE, Constants.SECURITY_CUBE]
};


// Industrial Violations
export const INDUSTRIAL_VIOLATIONS_ID = 'industrial-violations';
export const INDUSTRIAL_VIOLATIONS_NAME = 'Industrial Violations';
export const INITIAL_INDUSTRIAL_VIOLATIONS = {
    id: INDUSTRIAL_VIOLATIONS_ID,
    name: INDUSTRIAL_VIOLATIONS_NAME,
    cubes: [Constants.UNREST_CUBE, Constants.UNREST_CUBE]
};

// Nationalised Healthcare Spending
export const NATIONALISED_HEALTHCARE_SPENDING_ID = 'nationalised-healthcare-spending';
export const NATIONALISED_HEALTHCARE_SPENDING_NAME = 'Nationalised Healthcare Spending';
export const INITIAL_NATIONALISED_HEALTHCARE_SPENDING = {
    id: NATIONALISED_HEALTHCARE_SPENDING_ID,
    name: NATIONALISED_HEALTHCARE_SPENDING_NAME,
    cubes: [Constants.INCOME_CUBE, Constants.WELFARE_CUBE]
};


// Political Corruption
export const POLITICAL_CORRUPTION_ID = "political-corruption";
export const POLITICAL_CORRUPTION_NAME = "Political Corruption";
export const INITIAL_POLITICAL_CORRUPTION = {
    id: POLITICAL_CORRUPTION_ID,
    name: POLITICAL_CORRUPTION_NAME,
    cubes: [Constants.DEBT_CUBE, Constants.UNREST_CUBE]
};


// Security Spending
export const SECURITY_SPENDING_ID = 'security-spending';
export const SECURITY_SPENDING_NAME = 'Security Spending';
export const INITIAL_SECURITY_SPENDING = {
    id: SECURITY_SPENDING_ID,
    name: SECURITY_SPENDING_NAME,
    cubes: [Constants.INCOME_CUBE, Constants.SECURITY_CUBE]
};

// Special Operations
export const SPECIAL_OPERATIONS_ID = 'special-operations';
export const SPECIAL_OPERATIONS_NAME = 'Special Operations';
export const INITIAL_SPECIAL_OPERATIONS = {
    id: SPECIAL_OPERATIONS_ID,
    name: SPECIAL_OPERATIONS_NAME,
    cubes: [Constants.SECURITY_CUBE, Constants.UNREST_CUBE]
};

// Underfunded Police Force
export const UNDERFUNDED_POLICE_FORCE_ID = 'underfunded-police-force';
export const UNDERFUNDED_POLICE_FORCE_NAME = 'Underfunded Police Force';
export const INITIAL_UNDERFUNDED_POLICE_FORCE = {
    id: UNDERFUNDED_POLICE_FORCE_ID,
    name: UNDERFUNDED_POLICE_FORCE_NAME,
    cubes: [Constants.DEBT_CUBE, Constants.SECURITY_CUBE]
};

// Welfare Budget Problems
export const WELFARE_BUDGET_PROBLEMS_ID = 'welfare-budget-problems';
export const WELFARE_BUDGET_PROBLEMS_NAME = 'Welfare Budget Problems';
export const INITIAL_WELFARE_BUDGET_PROBLEMS = {
    id: WELFARE_BUDGET_PROBLEMS_ID,
    name: WELFARE_BUDGET_PROBLEMS_NAME,
    cubes: [Constants.DEBT_CUBE, Constants.WELFARE_CUBE]
};


// Welfare Cheat Crackdown
export const WELFARE_CHEAT_CRACKDOWN_ID = 'welfare-cheat-crackdown';
export const WELFARE_CHEAT_CRACKDOWN_NAME = 'Welfare Cheat Crackdown';
export const INITIAL_WELFARE_CHEAT_CRACKDOWN = {
    id: WELFARE_CHEAT_CRACKDOWN_ID,
    name: WELFARE_CHEAT_CRACKDOWN_NAME,
    cubes: [Constants.SECURITY_CUBE, Constants.WELFARE_CUBE]
};

// Welfare Cheats
export const WELFARE_CHEATS_ID = 'welfare-cheats';
export const WELFARE_CHEATS_NAME = 'Welfare Cheats';
export const INITIAL_WELFARE_CHEATS = {
    id: WELFARE_CHEATS_ID,
    name: WELFARE_CHEATS_NAME,
    cubes: [Constants.UNREST_CUBE, Constants.WELFARE_CUBE]
};